<template>
  <div class="flyouts-store-assign-info-flyout lg:flyout-indicator lg:indicator-contrast text-sm">
    <template v-if="localStore !== undefined && localStore !== null">
      <div 
        class="local-store border lg:border-none lg:flyout flex flex-col left-auto right-0 
        lg:absolute lg:w-[380px] text-paragraph" @trigger="close">
        <div class="flex gap-4 items-center p-4 pt-3 pr-5">
          <BasicIcon :name="'location-dot-solid'" class="w-5 text-primary" />
          <div class="flex gap-4 w-full justify-between items-center">
            <div>
              <div>Ist die Auswahl korrekt?</div>
              <div class="font-bold">{{ localStore?.zip }} {{ localStore?.city }}</div>
            </div>
            <div class="text-primary cursor-pointer" @click="openStorefinderPopUp()">Fachmarkt ändern</div>
          </div>
        </div>
        <button class="absolute top-1 right-1 text-primary" aria-label="Schließen" @click="close">
          <BasicIcon :name="'xmark-solid'" class="w-4" />
        </button>
      </div>
    </template>
    <template v-else>
      <OnClickOutside class="local-store flyout flex flex-col border border-solid border-secondary w-full left-0 sm:left-auto sm:right-0 absolute sm:w-[350px]" @trigger="close">
        <div class="NoStore p-4">Kein Fachmarkt ausgewählt</div>
        <div class="noStoreButton">
          <button type="button" class="btn-primary w-full flex items-center justify-center p-4 gap-2" @click="openStorefinderPopUp()">
            <BasicIcon :name="'location-dot-solid'" class="w-4" />Fachmarkt finden
          </button>
        </div>
      </OnClickOutside>
    </template>
  </div>
</template>
<script setup lang="ts">
import { ProvideNames } from '#shared/statics';

const showLocalStoreFinder = false
const emit = defineEmits(["changeFlyOutState"]);
const storeRef = inject(ProvideNames.CURRENT_STORE_KEY);
const localStore = storeRef?.currentStore;
const route = useRoute()

function close() {
  emit("changeFlyOutState", showLocalStoreFinder);
}

watch(() => route.path, close);
function openStorefinderPopUp() {
  usePopupQueue().enqueue({
    id: 'Storefinder',
  });
}
</script>
<style lang="postcss" scoped>
  @keyframes wiggle {
    0% { transform: rotate(0deg) translatey(1rem); }
    80% { transform: rotate(0deg) translatey(1rem); }
    85% { transform: rotate(1deg) translatey(1rem); }
    95% { transform: rotate(-1deg) translatey(1rem); }
    100% { transform: rotate(0deg) translatey(1rem); }
  }
  
  .flyouts-store-assign-info-flyout {
    @apply lg:translate-y-2 lg:animate-[wiggle_1.5s_ease-in-out_infinite];
  }
</style>